export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/AG-29c6210d968ed46d426ede8c47287552.png";